// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__3LBP3","vertical":"Checkbox_vertical__2H4JL"};